<footer class="site-footer">
  <div class="site-footer__inner">
    <p class="site-footer__text">{{ brand.copyright }}</p>
    @if (buildInfo(); as info) {
      <a
        class="site-footer__build-info"
        routerLink="/about"
        [attr.aria-label]="
          'View build details for ' +
          environmentLabel(info.environment) +
          ' version ' +
          info.version +
          ' release ' +
          info.releaseTag +
          ' from commit ' +
          info.commit
        "
      >
        <span class="site-footer__version">v{{ info.version }}</span>
        <span class="site-footer__separator" aria-hidden="true">·</span>
        <span class="site-footer__environment">{{ environmentLabel(info.environment) }}</span>
        <span class="site-footer__separator" aria-hidden="true">·</span>
        <span class="site-footer__deployed">deployed {{ deployedDate(info.deployedAt) }}</span>
      </a>
    }
  </div>
</footer>
